import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CountrySelectionService } from './country-selection.service';
import { switchMap } from 'rxjs/operators';
import { ApiConfigService } from './api-config.service';
import { CsrfService } from './csrf.service';

@Injectable({
  providedIn: 'root'
})
export class UserSurveyService {

  constructor(private http: HttpClient, private countrySelectionService: CountrySelectionService, private apiConfigService: ApiConfigService, private csrfService: CsrfService) { }

  getSurveyQuestions(): Observable<any> {
    return this.countrySelectionService.selectedCountry$.pipe(
      switchMap(country => {
        const apiUrl = this.countrySelectionService.getApiUrl('user_survey_export', country);
        return this.http.get(apiUrl);
      })
    );
  }

  submitSurvey(data: any): Observable<any> {
    const apiUrl = this.apiConfigService.getApiUrl('survey_poll_response');
    return this.csrfService.getCsrfToken().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'X-CSRF-Token': token
        });
        return this.http.post(apiUrl, data, { headers });
      })
    );
  }

  submitOpinionSurvey(data: any): Observable<any> {
    return this.csrfService.getCsrfToken().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'X-CSRF-Token': token
        });
        return this.countrySelectionService.selectedCountry$.pipe(
          switchMap(country => {
            const apiUrl = this.countrySelectionService.getApiUrl('opinion_survey', country);
            return this.http.post(apiUrl, data, { headers });
          })
        );
      })
    );
  }

  submitHealthAssessmentSurvey(data: any): Observable<any> {
    return this.csrfService.getCsrfToken().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'X-CSRF-Token': token
        });
        return this.countrySelectionService.selectedCountry$.pipe(
          switchMap(country => {
            const apiUrl = this.countrySelectionService.getApiUrl('health_assessment_survey', country);
            return this.http.post(apiUrl, data, { headers });
          })
        );
      })
    );
  }
}
